<template>
  <div class="ny">
    <div class="main">
      <div class="ny_bt1 mh md40">
        <span class="bt left">新增救助申请</span>
      </div>
      <ul class="lc1 mh md40">
        <li class="active">
          <span>1</span>
          <p>填写救助申请信息</p>
        </li>
        <li class="active">
          <span>2</span>
          <p>填写患儿家庭情况信息</p>
        </li>
        <li class="active">
          <span>3</span>
          <p>提交申请成功</p>
        </li>
      </ul>
    <div class="sq_ts mh">
         <i class="el-icon-success zt_lv icon_da md20"></i>
        <h3 class="md15">救助申请提交成功！</h3>
        <p class="zt_9 md40">感谢您的申请，我院工作人员将即时进行审核，在审核过程，系统会发送邮件和短信告知您审批结果，谢谢！</p>
         <el-button type="primary" @click="open_page('/user/userhome')">返回首页</el-button>
    </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {
  
   },
  created: function () {
    // this.$emit('header', false);
  },

};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/page/user/usersuc_sq3.vue